import React from 'react'
import'./About.css'
import ME from '../../assets/Niagra_1.png'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'

const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about_container">
        <div className="about_me">
          <div className="about_me-image">
            <img src={ME} alt="About Image" />
          </div>
        </div>

        <div className="about_content">
          <div className="about_cards">
            <article className='about_card'>
              <FaAward className='about_icon'/>
              <h5>Experience</h5>
              <small>3+ Years Working</small>
            </article>
            
            <article className='about_card'>
              <VscFolderLibrary className='about_icon'/>
              <h5>Projects</h5>
              <small>15+ Completed</small>
            </article>
          </div>

          <p>
          Hi, My name is Aman Shah. I am Mechatronics Student at Univeristy Of Waterloo who is intrested in Machine Learning, AI, CAD/CAM and Cloud. Over the last year, I’ve been working with Python, Java, JS, C/C++, ROS, Swift, and HTML/CSS. I am constantly searching to apply and polish my skills in means of creating innovative projects which help solve issues we face on a day-to-day basis.
          </p>
          <a href="#contact" className='btn btn-primary'>Let's Talk</a>

        </div>
      </div>
    </section>
  )
}

export default About